import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createSlots as _createSlots, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/insurance-policy/sample.png'


const _withScopeId = n => (_pushScopeId("data-v-7280cb52"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "block container-box" }
const _hoisted_2 = { class: "block-head" }
const _hoisted_3 = { class: "personnel" }
const _hoisted_4 = { class: "tool" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { class: "btn btn-white" }, "导入名单", -1))
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" #提示")
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {"color":"#2ea1ff"},
  src: _imports_0,
  alt: "",
  class: "sample"
}, null, -1))
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" 下载模板 ")
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "el-icon-upload" }, null, -1))
const _hoisted_11 = [
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line" }, null, -1))
const _hoisted_13 = { class: "table" }
const _hoisted_14 = { class: "row" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { class: "select-delete" }
const _hoisted_18 = {
  key: 0,
  class: "select-delete"
}
const _hoisted_19 = { class: "current-select" }
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" 已选择 ")
const _hoisted_21 = { class: "num" }
const _hoisted_22 = /*#__PURE__*/_createTextVNode(" 项 ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_page_head = _resolveComponent("page-head")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_select_personnel = _resolveComponent("select-personnel")!
  const _component_add_worker = _resolveComponent("add-worker")!
  const _component_set_worker = _resolveComponent("set-worker")!
  const _component_result_confirm = _resolveComponent("result-confirm")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_page_head, { title: _ctx.name }, _createSlots({
      left: _withCtx(() => [
        _createElementVNode("span", {
          class: _normalizeClass([_ctx.type === 'add' ? 'tag-green' : 'tag-red', "tag"])
        }, _toDisplayString(_ctx.type === 'add' ? '正在加保' : '正在减保'), 3)
      ]),
      _: 2
    }, [
      (_ctx.needStartDate)
        ? {
            name: "right",
            fn: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.type === 'add' ? '加保' : '减保') + "生效日期： ", 1),
              _createVNode(_component_el_date_picker, {
                modelValue: _ctx.startDate,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.startDate) = $event)),
                type: "date",
                placeholder: "请选择生效日期",
                format: "YYYY-MM-DD",
                "value-format": "YYYY-MM-DD"
              }, null, 8, ["modelValue"])
            ])
          }
        : undefined
    ]), 1032, ["title"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, " 本次" + _toDisplayString(_ctx.type === 'add' ? '加' : '减') + "保人员（" + _toDisplayString(_ctx.tableData.length) + "）人 ", 1),
        _createElementVNode("div", _hoisted_4, [
          (_ctx.type === 'subtract')
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "btn",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onSubtractAll && _ctx.onSubtractAll(...args)))
              }, " 一键全减 "))
            : _createCommentVNode("", true),
          _createElementVNode("button", {
            class: "btn",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isWorkerSelect = true))
          }, " 在线选择 "),
          _createElementVNode("button", {
            class: "btn btn-white",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.isAddWorker = true))
          }, " 手工录入 "),
          _createVNode(_component_el_upload, {
            action: "/",
            onChange: _ctx.onImport,
            accept: ".csv, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            "http-request": () => {},
            "show-file-list": false
          }, {
            default: _withCtx(() => [
              _hoisted_5
            ]),
            _: 1
          }, 8, ["onChange", "http-request"]),
          _createVNode(_component_el_tooltip, {
            class: "tooltip",
            effect: "light",
            placement: "bottom-end"
          }, {
            content: _withCtx(() => [
              _hoisted_6,
              _hoisted_7,
              _hoisted_8
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", {
                class: "download point",
                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.downloadTemplete && _ctx.downloadTemplete(...args)))
              }, _hoisted_11)
            ]),
            _: 1
          })
        ])
      ]),
      _hoisted_12,
      _createElementVNode("div", _hoisted_13, [
        _createVNode(_component_el_table, {
          data: _ctx.tableData,
          style: {"width":"100%"},
          "header-cell-class-name": "table-head",
          "row-style": { color: '#5E617D' },
          onSelectionChange: _ctx.handleSelectionChange
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, { type: "selection" }),
            _createVNode(_component_el_table_column, {
              type: "index",
              width: "80",
              fixed: "",
              label: "序号"
            }),
            _createVNode(_component_el_table_column, {
              prop: "name",
              width: "140",
              fixed: "",
              label: "姓名"
            }),
            _createVNode(_component_el_table_column, {
              prop: "idcard",
              label: "身份证号"
            }),
            (_ctx.type === 'add')
              ? (_openBlock(), _createBlock(_component_el_table_column, {
                  key: 0,
                  prop: "company_name",
                  label: "被派遣单位"
                }))
              : _createCommentVNode("", true),
            (_ctx.type === 'add')
              ? (_openBlock(), _createBlock(_component_el_table_column, {
                  key: 1,
                  prop: "occupation_name",
                  label: "所属工种"
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_el_table_column, {
              fixed: "right",
              width: "100",
              label: "操作"
            }, {
              default: _withCtx((scope) => [
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("span", {
                    class: "link",
                    onClick: ($event: any) => (_ctx.editWorker(scope.row))
                  }, " 编辑 ", 8, _hoisted_15),
                  _createElementVNode("span", {
                    class: "link red",
                    onClick: ($event: any) => (_ctx.deleteWorker(scope.row))
                  }, " 删除 ", 8, _hoisted_16)
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data", "onSelectionChange"])
      ])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass([{ foot: _ctx.$store.state.collapse, 'foot-nav': true }])
    }, [
      _createElementVNode("div", _hoisted_17, [
        (_ctx.selects.length !== 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _hoisted_20,
                _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.selects.length), 1),
                _hoisted_22
              ]),
              _createElementVNode("div", {
                class: "delete point",
                onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.deleteSelect && _ctx.deleteSelect(...args)))
              }, " 删除选中 ")
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", null, [
        (_ctx.selects.length !== 0 && _ctx.type === 'add')
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "btn-white",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.isSetWorker = true))
            }, " 设置工种 "))
          : _createCommentVNode("", true),
        (_ctx.type === 'add')
          ? (_openBlock(), _createElementBlock("button", {
              key: 1,
              onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.onSubmitAdd && _ctx.onSubmitAdd(...args))),
              class: "btn"
            }, " 确认加保 "))
          : _createCommentVNode("", true),
        (_ctx.type === 'subtract')
          ? (_openBlock(), _createElementBlock("button", {
              key: 2,
              onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.onSubmitSubtract && _ctx.onSubmitSubtract(...args))),
              class: "btn"
            }, " 确认减保 "))
          : _createCommentVNode("", true)
      ])
    ], 2),
    (_ctx.isWorkerSelect)
      ? (_openBlock(), _createBlock(_component_select_personnel, {
          key: 0,
          onClose: _cache[9] || (_cache[9] = ($event: any) => (_ctx.isWorkerSelect = false)),
          onConfirm: _ctx.workerSelect,
          policyId: _ctx.type === 'subtract' && _ctx.id ? _ctx.id : ''
        }, null, 8, ["onConfirm", "policyId"]))
      : _createCommentVNode("", true),
    (_ctx.isAddWorker)
      ? (_openBlock(), _createBlock(_component_add_worker, {
          key: 1,
          type: _ctx.type,
          dispatch: _ctx.dispatchList,
          onCancel: _ctx.cancelWorkerAdd,
          onComplete: _ctx.workerAdd,
          init: _ctx.addWorkerInit
        }, null, 8, ["type", "dispatch", "onCancel", "onComplete", "init"]))
      : _createCommentVNode("", true),
    (_ctx.isSetWorker)
      ? (_openBlock(), _createBlock(_component_set_worker, {
          key: 2,
          dispatch: _ctx.dispatchList,
          onCancel: _cache[10] || (_cache[10] = ($event: any) => (_ctx.isSetWorker = false)),
          onComplete: _ctx.workerSet
        }, null, 8, ["dispatch", "onComplete"]))
      : _createCommentVNode("", true),
    (_ctx.isConfirm)
      ? (_openBlock(), _createBlock(_component_result_confirm, {
          onSubmit: _ctx.isConfirm,
          onCancel: _cache[11] || (_cache[11] = ($event: any) => (_ctx.isConfirm = undefined)),
          name: _ctx.name,
          count: _ctx.tableData.length,
          money: _ctx.payMoney,
          addCount: _ctx.payCount,
          isMonth: _ctx.planType === '月保单',
          type: _ctx.type,
          date: _ctx.startDate,
          key: _ctx.resultKey,
          rule: _ctx.rule
        }, null, 8, ["onSubmit", "name", "count", "money", "addCount", "isMonth", "type", "date", "rule"]))
      : _createCommentVNode("", true)
  ], 64))
}